import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import Career from '../views/Career.vue'
import JobExperience from '../views/JobExperience.vue'
import ProjectsPage from '../views/ProjectsPage.vue'
import ProjectDetail from '../views/ProjectDetail.vue'
// import Portfolio from '../views/Portfolio.vue'
// import Blog from '../views/Blog.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/career',
    name: 'Career',
    component: Career
  },
  {
    path: '/career/:id',
    name: 'JobExperience',
    component: JobExperience
  },
  {
    path: '/projects',
    name: 'Projects',
    component: ProjectsPage
  },
  {
    path: '/projects/:id',
    name: 'ProjectDetail',
    component: ProjectDetail
  },
//   {
//     path: '/portfolio',
//     name: 'Portfolio',
//     component: Portfolio
//   },
//   {
//     path: '/blog',
//     name: 'Blog',
//     component: Blog
//   }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router 